//  BL Team Department Chooser
if (document.getElementById('departmentChooser')) {
    const teamSelect = document.getElementById('departmentChooser');

    const showteam = () => {

        let department = teamSelect.value;

        document.querySelectorAll('.mtt-main .member').forEach(function (teamer) {

            if (teamer.classList.contains(department)) {

                //  teamer.classList.add('hello');
                setTimeout(function (e) {
                    teamer.classList.add('grow');
                }, 200);
                setTimeout(function (e) {
                    teamer.classList.add('hello');
                }, 400);
                setTimeout(function (e) {
                    teamer.classList.add('fadein');
                }, 600);
            } else {
                teamer.classList.remove('fadein');
                setTimeout(function (e) {
                    teamer.classList.remove('hello');
                }, 150);
                setTimeout(function (e) {
                    teamer.classList.remove('grow');
                }, 300);
            }
        });
    }

    teamSelect.addEventListener('change', function () {
        showteam(); //  Do something damnit
    });

    showteam();
}